module.exports = __webpack_public_path__ + "assets/b9b2321033497c097fd9aebe5745422a.mp3";